var _path, _rect, _rect2, _rect3, _path2, _circle, _circle2, _rect4, _circle3, _circle4, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnclave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 34C28 22.954 36.954 14 48 14H70C92.091 14 110 31.909 110 54V72C110 92.987 92.987 110 72 110H54C39.641 110 28 98.359 28 84V34Z",
    fill: "#18324D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36,
    width: 31,
    height: 40,
    rx: 8,
    fill: "#FFF8EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 26,
    width: 31,
    height: 40,
    rx: 8,
    fill: "#FFD267"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 40,
    width: 28,
    height: 36,
    rx: 8,
    fill: "#72E3D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 85C48.5 79 61 77.5 71 80",
    stroke: "#72E3D2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 80,
    r: 15,
    fill: "#FF7B61"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 80,
    r: 9.5,
    fill: "#18324D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 88,
    width: 20,
    height: 6,
    rx: 3,
    transform: "rotate(45 92.5 88)",
    fill: "#18324D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 83,
    r: 5,
    fill: "#FFD267"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 32,
    r: 4,
    fill: "#72E3D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20C93 16 99 16 102 20",
    stroke: "#FF7B61",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnclave);
export default __webpack_public_path__ + "static/media/enclave.cf5401d71fac2a4ff3efb2df8bfc2218.svg";
export { ForwardRef as ReactComponent };